<template>
  <div class="wrapper-items wh100p">
    <section class="section-navs df">
      <div class="nav _themecolor active f-m">{{$t('qrcode.qrcodeInvalidManage')}}</div>
    </section>

    <section class="section-item df-c-sb" v-for="(x1, i1) in qrCodeList" :key="i1" v-if="qrCodeShow[x1.key]">
      <div>{{$t('qrcode.'+x1.label)}}</div>
      <div class="themebtn-s" @click="openClick(x1.key,x1.value)">
        <template v-if="qrCodeStatus[x1.key]">
          <div class="df-c-sa">
            <div class="f1" @click.stop.prevent="closeClick(x1.key,x1.value)">{{$t('qrcode.close')}}</div>
            <div class="line"></div>
            <el-popover width="150" v-model="qrCodePopup[x1.key]">
              <div class="popper-content">
                <div class="item f-xxs _c5" v-for="(x2, i2) in timeList" :key="i2"
                  @click="timeClick(x1.key,x1.value,x2.value)">{{$t('qrcode.'+x2.label)}}</div>
              </div>
              <template slot="reference">
                <div class="more">
                  <i :class="'el-icon-arrow-'+(qrCodePopup[x1.key]?'up':'down')"></i>
                </div>
              </template>
            </el-popover>
          </div>
        </template>
        <template v-else>{{$t("qrcode.open")}}</template>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'qrcode',
  data() {
    return {
      qrCodeList: [
        {label:'qrcodeLine',key:'lineUpQr',value:1},
        {label:'qrcodeTable',key:'foodTableQr',value:2},
        {label:'qrcodeTangshi',key:'totalTangShiQr',value:4},
        {label:'qrcodeTakeaway',key:'totalTakeOutQr',value:3},
      ],
      timeList: [
        {label:'1hour',value:1 },
        {label:'2hour',value:2 },
        {label:'4hour',value:4 },
        {label:'8hour',value:8 },
        {label:'utillClose',value:-1},
      ],
      qrCodeStatus: {
        lineUpQr: false,
        foodTableQr: false,
        totalTangShiQr: false,
        totalTakeOutQr: false,
      },
      qrCodeShow: {
        lineUpQr: false,
        foodTableQr: false,
        totalTangShiQr: false,
        totalTakeOutQr: false,
      },
      qrCodePopup: {
        lineUpQr: false,
        foodTableQr: false,
        totalTangShiQr: false,
        totalTakeOutQr: false,
      },
    }
  },
  watch: {
    sceneId_x(nval, oval) {
      if (nval && this.currentRoute === 'qrcode') {
        this.init_afterSceneChange()
      }
    },
  },
  methods: {
    ...mapMutations(['sceneId_x_save', 'modelList_x_save']),

    openClick(key, val) {
      if (this.qrCodeStatus[key]) return
      // console.log('openClick', key)
      this.setQrCodeStatus({ operationType: val, status: true })
    },
    closeClick(key, val) {
      // console.log('closeClick', key)
      this.setQrCodeStatus({ operationType: val, status: false })
    },
    timeClick(key, val, timeType) {
      // console.log('timeClick', key, val, timeType)
      this.setQrCodeStatus({ operationType: val, status: false, timeType })
      this.qrCodePopup[key] = false
    },

    setQrCodeStatus(data) {
      const rD = {
        shopId: this.currentShopId,
        ...data,
      }
      this.$api.qrcode_set(rD).then(res => {
        if (res.status == 0) {
          // console.log(`%cres:`, 'color: #f00;', res)
          this.getQrCodeStatus()
        } else { this._status(res) }
      })
    },
    
    getQrCodeStatus() {
     return this.$api.qrcode_get({ shopId: this.currentShopId }).then(res => {
        if (res.status == 0) {
          // console.log(`%cres:`, 'color: #f00;', res)
          if (res.data && res.data.length) {
           const {
              enableQueuingQr,
              enableTableQr,
              enableMainQrCodeDineIn,
              enableMainQrCodeTakeAway,
              // lastQueueQrSelectTime,
              // lastTableQrSelectTime,
              // lastMainQrCodeDineInSelectTime,
              // lastMinQrCodeTakeAwaySelectTime,
            } = res.data[0]
            this.qrCodeStatus.lineUpQr = enableQueuingQr
            this.qrCodeStatus.foodTableQr = enableTableQr
            this.qrCodeStatus.totalTangShiQr = enableMainQrCodeDineIn
            this.qrCodeStatus.totalTakeOutQr = enableMainQrCodeTakeAway
          }
          // console.log(`%cthis.qrCodeStatus:`, 'color: #00f;', this.qrCodeStatus)
        } else { this._status(res) }
      })
    },
    async modelHanlde(modelList) {
      // console.log(`%c运行模式:`, 'color: #00f;', modelList)
      const ITEM_TYPE_3 = modelList.find(x => x.type === 3)
      this.qrCodeShow.foodTableQr = !!ITEM_TYPE_3 && ITEM_TYPE_3.enable

      const ITEM_TYPE_1 = modelList.find(x => x.type === 1)
      let switchMaster = !!ITEM_TYPE_1 && ITEM_TYPE_1.enable
      this.qrCodeShow.totalTangShiQr = switchMaster && ITEM_TYPE_1.tangshi
      this.qrCodeShow.totalTakeOutQr = switchMaster && ITEM_TYPE_1.takeout

      this.qrCodeShow.lineUpQr = true
    },
    // 获取数据
    async init_afterSceneChange() {
      if (this.sceneId_x) {
        // console.log(`%c已保存的模式列表:`, 'color: #00f;', this.modelList_x)
        await this.getQrCodeStatus()
        this.modelHanlde(this.modelList_x)
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.$parent.$parent.$parent.initScene(vm.sceneId_x)
      vm.init_afterSceneChange()
    })
  },
}
</script>

<style lang='scss' scoped>
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;
  overflow: scroll hidden;
  .nav{padding: 0 10px;width: auto;white-space: nowrap;}
  .nav.active{font-weight: bold;}
}
.section-item{
  height: 80px;line-height: 80px;background: #fff;margin: 20px 0 20px 20px;
  padding: 0 20px;
  .themebtn-s {padding: 0;}
  .line {width: 2px;height: 16px;background-color: #fff;}
  .more {width: 28px;}
}
.popper-content{
  .item{text-align: center;height: 36px;line-height: 36px;}
  .item.ac{background-color: #F5F7FA;color: #374978;font-weight: 700;}
}
</style>